// Test IDs for the premium homepage hero module (navbar, hero, showcase,
// stats, feature cards, closing CTA). Naming follows ./auth.js directive.

export const HERO = {
  navRoot: 'hero-navbar',
  navLogo: 'hero-nav-logo',
  navLinkShowcase: 'hero-nav-link-showcase',
  navLinkResults: 'hero-nav-link-results',
  navLinkFeatures: 'hero-nav-link-features',
  navCta: 'hero-nav-cta',
  navMobileToggle: 'hero-nav-mobile-toggle',
  navMobileMenu: 'hero-nav-mobile-menu',
  root: 'hero-section-root',
  eyebrow: 'hero-eyebrow',
  headline: 'hero-headline',
  subheadline: 'hero-subheadline',
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
  trustBadge: (i) => `hero-trust-badge-${i}`,
  scrollIndicator: 'hero-scroll-indicator',
  showcaseRoot: 'hero-showcase-root',
  laptopMockup: 'hero-laptop-mockup',
  aiWidget: 'hero-ai-assistant-widget',
  aiWidgetInput: 'hero-ai-assistant-input',
  aiWidgetSend: 'hero-ai-assistant-send',
  aiWidgetMessages: 'hero-ai-assistant-messages',
  notification: (i) => `hero-floating-notification-${i}`,
  statsRoot: 'hero-stats-root',
  statCard: (i) => `hero-stat-card-${i}`,
  featuresRoot: 'hero-features-root',
  featureCard: (i) => `hero-feature-card-${i}`,
  ctaBandRoot: 'hero-cta-band-root',
  ctaBandButton: 'hero-cta-band-button',
};
